import React, { useState } from 'react';
import { CHARACTER_VOICES, normalizeCharacterVoices, setCharacterVoice, effectiveDialogueVoiceId } from '../core/characterVoices.js';
import { VoicePreview } from './VoicePreview.jsx';

export function CharacterVoices({ scenario, onChange, identity }) {
  const [previewId, setPreviewId] = useState(null);
  const voices = normalizeCharacterVoices(scenario.characterVoices, scenario.characters);
  const dialogueVoice = id => effectiveDialogueVoiceId({ ...scenario, characterVoices: voices }, id);
  const selected = scenario.characters.find(c => c.id === previewId);
  const choice = selected && voices.assignments[selected.id];
  const selectedVoiceId = selected && dialogueVoice(selected.id);
  const available = choice && CHARACTER_VOICES.some(v => v.id === selectedVoiceId);
  return <article className="editor-section surface" aria-label="Character voices">
    <h2>Character voices</h2>
    <p>Voicebox · Kokoro. Choices save with this project in this browser and in exported backups. Prepared browser rehearsals use these character voices. The desktop app keeps its bundled voices.</p>
    <div className="editor-fields">{scenario.characters.map(character => {
      const voice = voices.assignments[character.id];
      const voiceId = dialogueVoice(character.id);
      const supported = CHARACTER_VOICES.some(v => v.id === voiceId);
      return <div key={character.id}>
        <label>Voice for {character.name}<select value={voiceId || ''} onChange={event => onChange(setCharacterVoice(scenario, character.id, event.target.value))}>
          {!supported && <option value={voice.nativeVoiceId || ''}>{voice.nativeVoiceId ? `Unavailable: ${voice.nativeVoiceId}` : 'Choose a voice — character identity needs review'}</option>}
          {CHARACTER_VOICES.map(v => <option key={v.id} value={v.id}>{v.name} · {v.id}</option>)}
        </select></label>
        <small>{voice.source === 'manual' ? 'Your choice' : voice.source === 'automatic' ? 'Initial choice' : 'Selection required'}</small>
        <button className="button secondary" disabled={!identity || !supported} onClick={() => setPreviewId(character.id)}>Preview {character.name}</button>
      </div>;
    })}</div>
    {!identity && <p>To preview, open a Director room for this project, then return here to edit. Choices can be saved without speech being available.</p>}
    {selected && available && identity && <VoicePreview key={`${identity.roomCode}:${selected.id}:${selectedVoiceId}`} identity={identity} selectedVoiceId={selectedVoiceId} previewLabel={selected.name} />}
  </article>;
}
